import { Box, Flex, Image, Text, VStack } from "@chakra-ui/react";
import { Images } from "../../Assets/images";
import React, { useEffect, useState } from "react";
import { BsFillPersonFill } from "react-icons/bs";
import { MdCardGiftcard, MdOutlinePermMedia, MdArrowBack, MdOutlineCardMembership } from "react-icons/md";
import { BiSolidLockAlt } from "react-icons/bi";
import { IoLogOut } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { handleLogout } from "../../Utils/logout";
import { formatVersion, getCachedServerHash } from "../../Utils/version"; // Claude: version display 28-03-2026
import { errorHandler } from "../../Utils/handler";
import { BuyerAPI } from "../../Apis/buyerAPI";
import { useToastWrapper } from "../../Wrapper/toastWrapper";
import { Modal } from "antd";
import LogoutWarningModal from "../../Components/Modals/LogoutWarningModal";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../redux/Actions";
import SupportModal from "../../Components/Modals/SupportModal";
import { MdOutlineSupportAgent } from "react-icons/md";
import { Buyerscreens } from "../../Constants/data";

const Account = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  // Claude: verification badge next to My Profile 19-03-2026
  const verificationStatus = useSelector((state: any) => state.user?.verificationStatus);

  const [data, setData] = useState<any>();
  const [hasRewards, setHasRewards] = useState(false); // Claude: show Rewards only if entries exist 27-03-2026

  const { success, error } = useToastWrapper();

  const dispatch = useDispatch();

  const [logoutModal, setLogoutModal] = useState(false);

  const handleLogoutUser = () => {
    setLogoutModal(false);
    handleLogout(); // Claude: purges localStorage + redirects to /login 06-03-2026
  };

  const handleCloseLogoutModal = () => {
    setLogoutModal(false);
  };

  const handleOpenLogoutModal = () => {
    setLogoutModal(true);
  };

const [supportModal, setSupportModal] = useState(false);

  const handleOpenSupportModal = () => {
    setSupportModal(true);
  };

  const handleCloseSupportModal = () => {
    setSupportModal(false);
  };

  const getData = async () => {
    setLoading(true);
    try {
      const res = await BuyerAPI.getBuyerProfile();
      if (res) {
        console.log("Buyer Profile is:",res)
        const obj = {
          name: res.data.data?.buyerPersonName,
          companyName: res.data.data?.buyerCompanyName,
          designation: res.data.data?.buyerDesignation,
          workEmail: res.data.data?.buyerOfficialEmail,
          // socialEmail: res.data.data?.personEmail,
          phoneNumber: res.data.data?.buyerPhoneNumber,
          // companyWebsite: res.data.data?.companyUrl,
          buyerTimezone: res.data.data?.buyerTimezone,
          buyerCompanyWebsite: res.data.data?.buyerCompanyWebsite, //Vishy added 04-June-2025
          buyerCompanyInfo: res.data.data?.buyerCompanyInfo //Vishy added 04-June-2025
        };
        setData(obj);
        // Claude: check if buyer has any rewards entries 27-03-2026
        try {
          const buyerId = res.data.data?._id;
          if (buyerId) {
            const rewardsRes = await BuyerAPI.getRewardsByBuyerId({ buyerId });
            const rewardsArr = rewardsRes?.data?.data?.rewards;
            setHasRewards(Array.isArray(rewardsArr) && rewardsArr.length > 0);
          }
        } catch (_) {}
      }
    } catch (err) {
      console.log(err);
      error(errorHandler(err));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
    dispatch(
      actions.buyerMenu.set({
        activeMenu: Buyerscreens.PROFILE
      })
    )
  }, []);

  // Claude: Redesigned to match Seller Account page — dark header, white bg items 23-02-2026
  return (
    <Box w={"100%"} display={"flex"} flexDirection={"column"} minH={"100dvh"}>
      <Modal
        closeIcon={null}
        footer={null}
        title={null}
        open={logoutModal}
        onOk={handleCloseLogoutModal}
        onCancel={handleCloseLogoutModal}
      >
        <LogoutWarningModal
          handleCloseModal={handleCloseLogoutModal}
          handleSubmit={handleLogoutUser}
        />
      </Modal>
      <Modal
        closeIcon={null}
        footer={null}
        title={null}
        open={supportModal}
        onOk={handleCloseSupportModal}
        onCancel={handleCloseSupportModal}
      >
        <SupportModal handleCloseModal={handleCloseSupportModal} />
      </Modal>

      {/* Dark header matching other pages */}
      <Flex
        w={"100%"}
        px={"30px"}
        py={5}
        bg={"#0E122F"}
        color={"white"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        {/* Claude: back arrow → search/feeds page 11-04-2026 */}
        <Flex alignItems="center" gap={3} cursor="pointer" onClick={() => navigate("/buyer/rfxs")}>
          <MdArrowBack size={20} color="white" />
          <Text fontSize={"xl"} fontWeight={700}>Account Info</Text>
        </Flex>
        {/* Claude: role label below logo in header 25-02-2026 */}
        <VStack spacing={0} alignItems="center" justifyContent="center">
          <Image src={Images.AftrLogo} h="32px" objectFit="contain" />
          <Text fontSize="11px" fontWeight={300} color="whiteAlpha.600" letterSpacing="wide">
            buyer (beta)
          </Text>

        </VStack>
      </Flex>

      {/* Menu items on white bg */}
      <VStack spacing={0} w={"100%"} bg={"white"}>
        <Box
          display={"flex"}
          alignItems={"center"}
          py={"10px"}
          px={"20px"}
          gap={3}
          w={"100%"}
          cursor={"pointer"}
          borderBottom={"1px solid #E2E8F0"}
          onClick={() => navigate("/buyer/profile")}
        >
          <Box display={"flex"} alignItems={"center"} justifyContent={"center"} h={"36px"} w={"36px"} bg={"gray.100"} rounded={"10px"}>
            <BsFillPersonFill size={18} color={"#1C1B1F"} />
          </Box>
          <Text fontSize={"sm"} fontWeight={500} color={"gray.800"}>My Profile</Text>
          {/* Claude: verification status badge 19-03-2026 */}
          {verificationStatus === "unverified" && (
            <Text fontSize="10px" fontWeight={600} px={2} py="2px" borderRadius="6px" color="#9B2C2C" bg="#FED7D7">Unverified</Text>
          )}
          {(verificationStatus === "resubmitted" || verificationStatus === "provisional") && (
            <Text fontSize="10px" fontWeight={600} px={2} py="2px" borderRadius="6px" color="#7B341E" bg="#FEEBC8">Under Review</Text>
          )}
        </Box>

        {/* Claude: My Assets — buyer digital assets page 25-02-2026 */}
        <Box
          display={"flex"}
          alignItems={"center"}
          py={"10px"}
          px={"20px"}
          gap={3}
          w={"100%"}
          cursor={"pointer"}
          borderBottom={"1px solid #E2E8F0"}
          onClick={() => navigate("/buyer/catalog")}
        >
          <Box display={"flex"} alignItems={"center"} justifyContent={"center"} h={"36px"} w={"36px"} bg={"gray.100"} rounded={"10px"}>
            <MdOutlinePermMedia size={18} color={"#1C1B1F"} />
          </Box>
          <Text fontSize={"sm"} fontWeight={500} color={"gray.800"}>Digital Assets</Text>
        </Box>

        {/* Claude: Subscription Plan — buyer-facing plan usage view 11-Apr-2026 */}
        <Box
          display={"flex"}
          alignItems={"center"}
          py={"10px"}
          px={"20px"}
          gap={3}
          w={"100%"}
          cursor={"pointer"}
          borderBottom={"1px solid #E2E8F0"}
          onClick={() => navigate("/buyer/subscription")}
        >
          <Box display={"flex"} alignItems={"center"} justifyContent={"center"} h={"36px"} w={"36px"} bg={"gray.100"} rounded={"10px"}>
            <MdOutlineCardMembership size={18} color={"#1C1B1F"} />
          </Box>
          <Text fontSize={"sm"} fontWeight={500} color={"gray.800"}>Subscription Plan</Text>
        </Box>

        {/* Claude: Rewards — shown only if buyer has reward entries 27-03-2026 */}
        {hasRewards && (
          <Box
            display={"flex"}
            alignItems={"center"}
            py={"10px"}
            px={"20px"}
            gap={3}
            w={"100%"}
            cursor={"pointer"}
            borderBottom={"1px solid #E2E8F0"}
            onClick={() => navigate("/buyer/rewards")}
          >
            <Box display={"flex"} alignItems={"center"} justifyContent={"center"} h={"36px"} w={"36px"} bg={"gray.100"} rounded={"10px"}>
              <MdCardGiftcard size={18} color={"#1C1B1F"} />
            </Box>
            <Text fontSize={"sm"} fontWeight={500} color={"gray.800"}>Rewards</Text>
          </Box>
        )}

        <Box
          display={"flex"}
          alignItems={"center"}
          py={"10px"}
          px={"20px"}
          gap={3}
          w={"100%"}
          cursor={"pointer"}
          borderBottom={"1px solid #E2E8F0"}
          onClick={() => navigate("/reset-password")}
        >
          <Box display={"flex"} alignItems={"center"} justifyContent={"center"} h={"36px"} w={"36px"} bg={"gray.100"} rounded={"10px"}>
            <BiSolidLockAlt size={18} color={"#1C1B1F"} />
          </Box>
          <Text fontSize={"sm"} fontWeight={500} color={"gray.800"}>Change Password</Text>
        </Box>

        <Box
          display={"flex"}
          alignItems={"center"}
          py={"10px"}
          px={"20px"}
          gap={3}
          w={"100%"}
          cursor={"pointer"}
          borderBottom={"1px solid #E2E8F0"}
          onClick={() => handleOpenSupportModal()}
        >
          <Box display={"flex"} alignItems={"center"} justifyContent={"center"} h={"36px"} w={"36px"} bg={"gray.100"} rounded={"10px"}>
            <MdOutlineSupportAgent size={18} color={"#1C1B1F"} />
          </Box>
          <Text fontSize={"sm"} fontWeight={500} color={"gray.800"}>Support</Text>
        </Box>

        <Box
          display={"flex"}
          alignItems={"center"}
          py={"10px"}
          px={"20px"}
          gap={3}
          w={"100%"}
          cursor={"pointer"}
          onClick={() => handleOpenLogoutModal()}
        >
          <Box display={"flex"} alignItems={"center"} justifyContent={"center"} h={"36px"} w={"36px"} bg={"gray.100"} rounded={"10px"}>
            <IoLogOut size={18} color={"#1C1B1F"} />
          </Box>
          <Text fontSize={"sm"} fontWeight={500} color={"gray.800"}>Logout</Text>
        </Box>
        {/* Claude: version string below logout — pb clears bottom nav bar 28-03-2026 */}
        <Text fontSize={"10px"} color={"gray.400"} textAlign={"center"} mt={2} pb={"80px"}>
          {formatVersion(process.env.REACT_APP_GIT_HASH || '??', getCachedServerHash())}
        </Text>
      </VStack>
    </Box>
  );
};

export default Account;
